import Header from "../components/global/Header"
import Layout from "../components/global/Layout"
import AddPost from "../components/post/AddPost"

const WritePost = () =>{
  return(
    <Layout>
      <Header />
      <AddPost />
    </Layout>
  )
}

export default WritePost